// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__UmXXt","HomeBtn":"Home_HomeBtn__9PliS","Social":"Home_Social__UE6Q6"};